import { useEffect, useState } from "react";
import { SECTIONS } from "@/lib/sections";

export default function SideDots() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const container = document.getElementById("deck");
    if (!container) return;
    const onScroll = () => {
      const h = container.clientHeight;
      const idx = Math.round(container.scrollTop / h);
      setActive(Math.min(SECTIONS.length - 1, Math.max(0, idx)));
    };
    container.addEventListener("scroll", onScroll, { passive: true });
    return () => container.removeEventListener("scroll", onScroll);
    // SECTIONS is a module-level constant; container/onScroll are created inside
    // the effect — none can produce a stale closure. Empty deps is intentional.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const goTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      data-testid="side-dots"
      className="no-print fixed right-5 md:right-7 top-1/2 z-40 hidden -translate-y-1/2 flex-col gap-3.5 md:flex"
      aria-label="Section navigation"
    >
      {SECTIONS.map((s, i) => (
        <button
          key={s.id}
          data-testid={`dot-${s.id}`}
          onClick={() => goTo(s.id)}
          aria-label={`Section ${s.num} — ${s.label}`}
          title={s.label}
          className="group flex items-center justify-end"
        >
          <span
            className={`block transition-all duration-500 ease-luxe ${
              active === i
                ? "h-2 w-2 bg-gold"
                : "h-[5px] w-[5px] bg-ivory/30 group-hover:bg-ivory/70"
            }`}
            style={{ borderRadius: 0 }}
          />
        </button>
      ))}
    </nav>
  );
}
